import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-079c9ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "rule-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rule-title font-medium" }, "Regula de decontare automată:", -1))
const _hoisted_4 = {
  key: 0,
  class: "font-normal"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-double-right" }, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-double-right" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info w-auto font-normal" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(" După îndeplinirea condiției de decontare, viramentul beneficiului medicului în contul IBAN se face în zilele de decontare, conform contractului. ")
], -1))
const _hoisted_9 = { class: "rule-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rule-title font-medium" }, "Comision aplicație:", -1))

import { DoctorConfig } from '@/interfaces/DoctorConfig';
import { MoneyUtils } from '@/utils/MoneyUtils';
import { PropType, ref, watch } from 'vue';
import InputNumber from 'primevue/inputnumber';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorPayoutConfig',
  props: {
  modelValue: {
    type: Object as PropType<DoctorConfig>,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;

const thisDoctorConfig = ref<DoctorConfig>(
  props.modelValue || ({} as DoctorConfig)
);

watch(
  () => props.modelValue,
  (newValue) => {
    thisDoctorConfig.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (thisDoctorConfig.value.payoutDaysInterval)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" La interval de: " + _toDisplayString(thisDoctorConfig.value.payoutDaysInterval) + " zile", 1)
          ]))
        : _createCommentVNode("", true),
      (thisDoctorConfig.value.payoutMoneyLimit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" La atingerea venitului din consultații: " + _toDisplayString(_unref(MoneyUtils).formatd(thisDoctorConfig.value.payoutMoneyLimit)) + " lei ", 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_unref(InputNumber), {
        min: 0,
        max: 100,
        id: "commissionPercent",
        mode: "decimal",
        minFractionDigits: 2,
        maxFractionDigits: 2,
        modelValue: thisDoctorConfig.value.commissionPercent,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisDoctorConfig.value.commissionPercent) = $event)),
        pt: {
          root: {
            style: 'height: 5px !important;'
          },
          input: {
            style: 'width: 70px !important;'
          }
        }
      }, null, 8, ["modelValue"]),
      _createTextVNode(" % ")
    ])
  ]))
}
}

})